import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { ActionState, BaseComponentConfig, ComponentConfig, CustomContainerItem, StoreEditContainerComponent, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { STR_FORMS } from './forms';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { options } from './configoptions';

@Component({
  selector: 'ubs-stores',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./stores.component.scss']
})
export class StoresComponent extends BaseComponentConfig implements OnInit, OnChanges {
  handleError: any;
  stores: any[] = [];

  constructor(viewContainerService: ViewContainersService,
    menuService: NbMenuService,
    configurationService: ConfigurationService,
    route: ActivatedRoute,
    router: Router,
    updateComponentStoreService: UpdateComponentStoreService,
    private http: HttpClient) {
    super(viewContainerService, menuService, configurationService, route, router, updateComponentStoreService)
    options.defaultAction = ActionState.LIST;
    this.componentConfig = new ComponentConfig(options);
    this.route.paramMap.subscribe((params) => {
      this.routerParams = params;
      this.setAction(this.resolveParams(this.routerParams));
    })
    /* this.menuService.onItemClick().subscribe(menuBag => {
      this.resolveItem(menuBag.item.data);
      updateComponentStoreService.handleMenuItemSelected(menuBag.item.data);
    }) */
  }

  ngOnInit(): void {
    this.baseUrl = this.getBaseUrl();
    // this.getStores(this.baseUrl);
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    setTimeout(() => {
      this.componentConfig.menuAndTitleOptions.menuItems = [{ title: "Product Store", group: true }, { title: "Some Kak", group: true }]
      const menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
      if (menuAndTitleOptions != undefined) {
        console.log(menuAndTitleOptions);

        // let menuTag = menuAndTitleOptions.menuTag;
        // console.log(menuTag);
        /* let menuItems:NbMenuItem[] = [
          {title:"List Stores",icon:"list-outline"},
          {title:"New Store",icon:"plus-outline"},
          {title:"Product Stores",group:true,icon:"grid-outline"}
        ]; */
        // this.menuService.addItems(menuItems,menuTag)
      } else {
        console.error("No menuAndTitleOptions");
      }
    }, 100)

  }
  /**This function is used to retrieve the first five stores which is then added to the menu.
   * It is commented out
   *
   */
  /* getStores(baseUrl:string){
    let url:string = this.baseUrl+'widgets/grid/value/ListProductStore?location=component://kwikstore/widget/StoreForms.xml';
    this.http.get<any>(url).pipe(
      catchError(this.handleError),
      map(resp => {
        let message = resp["successMessage"]
        if(message == "OK"){
          let data = resp["data"];
            let formData = data["formData"];
            let rows:any[] = formData.rows;
            console.log(rows);
            rows.forEach((row:any[]) => {
              let store:any = {};
              row.forEach(field => {
                for(let[k,v] of Object.entries(field)){
                  store[k] = v;
                }
              })
              this.stores.push(store);
            })
        }
      })
    ).subscribe()
  }
 */
  createStoreMenuItems(stores: any[]): NbMenuItem[] {
    const menuItems: NbMenuItem[] = [];
    stores.forEach((store, i) => {
      const storeId = store["productStoreId"]
      const menuItem: NbMenuItem = { title: "" };
      menuItem.title = store["storeName"];
      if (i < 6) {
        menuItem.children = [
          {
            title: "Edit Store",
            link: "/admin/stores/store/" + storeId,
            icon: "edit-outline",
            data: {
              "event": "edit",
              "type": "EditProductStore",
              "label": "Edit Store " + storeId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              },
            }
          },
          {
            title: "Catalogs",
            link: "/admin/stores/store/" + storeId + "/catalogs",
            icon: "cube-outline",
            data: {
              "event": "relate",
              "type": "Catalogs",
              "label": "Catalogs for " + storeId,
              data: {
                formData: {
                  formName: "UpdateProductStoreCatalog",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Payment Settings",
            link: "/admin/stores/store/" + storeId + "/paymentSettings",
            icon: "credit-card-outline",
            data: {
              "event": "relate",
              "type": "Payment Settings",
              "label": "Payment Settings for " + storeId,
              data: {
                formData: {
                  formName: "ListProductStorePaymentSettings",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Facilities",
            link: "/admin/stores/store/" + storeId + "/facilities",
            icon: "home-outline",
            data: {
              "event": "relate",
              "type": "Facilities",
              "label": "Facilities for " + storeId,
              data: {
                formData: {
                  formName: "ListProductStoreFacility",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Roles",
            link: "/admin/stores/store/" + storeId + "/roles",
            icon: "people-outline",
            data: {
              "event": "relate",
              "type": "Roles",
              "label": "Roles for " + storeId,
              data: {
                formData: {
                  formName: "ListProductStoreRole",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Store Promotions",
            link: "/admin/stores/store/" + storeId + "/promotions",
            icon: "gift-outline",
            data: {
              "event": "relate",
              "type": "Store Promotions",
              "label": "Store Promotions " + storeId,
              data: {
                formData: {
                  formName: "ListProductStorePromos",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Shipment Methods",
            link: "/admin/stores/store/" + storeId + "/shipmentMethods",
            icon: "car-outline",
            data: {
              "event": "relate",
              "type": "Shipment Methods",
              "label": "Shipment Methods " + storeId,
              data: {
                formData: {
                  formName: "ListProductStoreShipmentMeths",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Shipment Cost Estimates",
            link: "/admin/stores/store/" + storeId + "/shipmentCostEstimates",
            icon: "question-mark-outline",
            data: {
              "event": "relate",
              "type": "Shipment Cost Estimates",
              "label": "Shipment Cost Estimates " + storeId,
              data: {
                formData: {
                  formName: "ListShipmentCostEstimates",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Financial Account Settings",
            link: "/admin/stores/store/" + storeId + "/financialAccountSettings",
            icon: "settings-outline",
            data: {
              "event": "relate",
              "type": "Financial Account Settings",
              "label": "Financial Account Settings " + storeId,
              data: {
                formData: {
                  formName: "ListProductStoreFinAccountSettings",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Store Email Settings",
            link: "/admin/stores/store/" + storeId + "/storeEmailSettings",
            icon: "at-outline",
            data: {
              "event": "relate",
              "type": "Store Email Settings",
              "label": "Store Email Settings " + storeId,
              data: {
                formData: {
                  formName: "UpdateProductStoreEmail",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Store Surveys",
            link: "/admin/stores/store/" + storeId + "/storeSurveys",
            icon: "clipboard-outline",
            data: {
              "event": "relate",
              "type": "Store Surveys",
              "label": "Store Surveys " + storeId,
              data: {
                formData: {
                  formName: "EditProductStoreSurveys",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Vendor Shipments",
            link: "/admin/stores/store/" + storeId + "/vendorShipments",
            icon: "settings-outline",
            data: {
              "event": "relate",
              "type": "Vendor Shipments",
              "label": "Vendor Shipments for " + storeId,
              data: {
                formData: {
                  formName: "ListProductStoreVendorShipments",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Vendor Payment Settings",
            link: "/admin/stores/store/" + storeId + "/vendorPaymentSettings",
            icon: "settings-outline",
            data: {
              "event": "relate",
              "type": "Vendor Payment Settings",
              "label": "Vendor Payment Settings for " + storeId,
              data: {
                formData: {
                  formName: "ListProductStoreVendorPayments",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          },
          {
            title: "Web Sites",
            link: "/admin/stores/store/" + storeId + "/webSites",
            icon: "globe-outline",
            data: {
              "event": "relate",
              "type": "Web Sites",
              "label": "Web Sites for " + storeId,
              data: {
                formData: {
                  formName: "EditProductStoreWebSites",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productStoreId: storeId }
              }
            }
          }
        ]
        menuItems.push(menuItem);
      }
    })
    return menuItems
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["routeParames"]) {
      console.log("Shit changed")
      console.log(this.routerParams);
    }
  }

  setAction(parameters: any) {
    const parts = this.router.url.split("/");
    console.log("Parts", parts, "Parameters", parameters)
  }

}

/**
 * export interface SelectedValue{
    /**
     * Event can be view,list,add or edit
     */
// event?:string;
/**
 * Type is formName/ListName/View
 */
// type?:string;
/**
 * Text value to be used in headers/breadCrumbs etc.
 */
// label?:string;
/**
 * Data: remoteFormData
 */
// data?:RemoteFormData;

// }
// */

export interface RemoteFormData {
  formData: {
    formName: string;
    formLocation: string;
    listType?: string;
    entityName?: string;
    viewIndex?: number;
    [key: string]: any;
  }
  endPoint?: string;
  appContext?: string;
  parameters?: {};
}






